var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('h1',{staticClass:"my-header"},[_vm._v("Accueil")])])
}]

export { render, staticRenderFns }